import { useCallback, useState } from 'react'

import {
  callAuthorizedGraphQLEndpoint,
  updateUserData,
  deleteUser,
} from 'Module/graphQL'
import { authorization } from 'Module/Auth/Auth'

export const getBrandAmbassadors = `
  query (
    $cityId: ID!, 
    $first: Int, 
    $after: String, 
    $hasInventory: Boolean, 
    $hasMissionsBooked: Boolean,
    $statuses: [UserStatusEnum!],
    $search: String,
    $orderBy: UserOrderByEnum,
    $skip: Int,
    $isWithholdPay: Boolean
  ) {
    city(id: $cityId){
      brandAmbassadors(
        first: $first,  
        after: $after, 
        hasInventory: $hasInventory,
        hasMissionsBooked: $hasMissionsBooked,
        statuses: $statuses,
        search: $search,
        orderBy: $orderBy,
        skip: $skip,
        isWithholdPay: $isWithholdPay
      ){
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          firstName
          lastName
          isTeamLeader
          status: statusV2
          memberSince
          rating
          itemCount
          documentsProvided
          mobilePhone
          email
          recruitmentChannel
          city {
            name
          }
          providedPersonalDocuments{
            edges {
              node {
                id
                url
                instructionText
                documentTypeName
                countryCode
              }
            }
          }
          missions{
            totalCount
            nodes {
              totalFlyersDistributed
              status
              dateTime
            }
          }
          withholdPay
        }
      }
    }
  }
`

export async function getListCalendarEvents(cityId) {
  const query = `query ($cityId: ID!) {
    listCalendarEvents(cityId: $cityId) {
      userId
      dateTime
      googleEventMetadata
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

const cache = {}
export const useAmbassadorsRequest = (cache => cityId => {
  const [
    progressOfGetAllAmbassadors,
    setProgressOfGetAllAmbassadors,
  ] = useState({
    isLoading: false,
  })
  const [isLoadGetAmbassadors, setIsLoadGetAmbassadors] = useState(false)

  const getAmbassadorCalendarEvents = useCallback(async () => {
    const response = await getListCalendarEvents(cityId)
    const result = await response.json()

    return result.data.listCalendarEvents
  }, [cityId])

  const getAmbassadors = useCallback(
    async (args, options = {}) => {
      setIsLoadGetAmbassadors(true)
      const key = JSON.stringify(args)

      if (!options.isFresh && cache[cityId + key]) {
        return cache[cityId + key]
      }

      const response = await callAuthorizedGraphQLEndpoint(
        getBrandAmbassadors,
        {
          cityId,
          ...args,
        },
      )

      const result = (await response.json()).data.city.brandAmbassadors
      setIsLoadGetAmbassadors(false)

      return (cache[cityId + key] = {
        ambassadors: result.nodes,
        totalCount: result.totalCount,
      })
    },
    [cityId, cache],
  )

  const getAllAmbassadors = useCallback(
    async (args, options = {}) => {
      const { progressName, isFresh } = options

      const updProgressInit = name => progress =>
        name
          ? setProgressOfGetAllAmbassadors({ [name]: progress })
          : setProgressOfGetAllAmbassadors(progress)

      const updProgress = updProgressInit(progressName)

      updProgress({
        isLoading: true,
      })

      var nodes = []
      var count
      const request = async params => {
        const key = JSON.stringify({ args, params })

        if (!isFresh && cache[cityId + key]) {
          return cache[cityId + key]
        }
        const response = await callAuthorizedGraphQLEndpoint(
          getBrandAmbassadors,
          {
            cityId,
            ...args,
            ...params,
          },
        )
        const result = (await response.json()).data.city.brandAmbassadors

        return (cache[cityId + key] = {
          ambassadors: result.nodes,
          totalCount: result.totalCount,
        })
      }

      while (typeof count == 'undefined' || count > nodes.length) {
        const { ambassadors, totalCount } = await request({
          first: 200,
          skip: nodes.length,
        })

        nodes = [...nodes, ...ambassadors]
        count = totalCount

        updProgress({
          isLoading: true,
          label: `${nodes.length} from ${totalCount}`,
        })
      }

      updProgress({
        isLoading: false,
      })

      return {
        ambassadors: nodes,
        totalCount: count,
      }
    },
    [cityId, cache, progressOfGetAllAmbassadors],
  )

  const updateAmbassador = useCallback(
    async (id, data) => {
      const authToken = await authorization.getAPIKey()
      const response = await updateUserData(authToken, id, data)
      const result = await response.json()

      return result
    },
    [cityId],
  )

  const deleteAmbassador = useCallback(
    async id => {
      const authToken = await authorization.getAPIKey()
      const response = await deleteUser(authToken, id)
      const result = await response.json()

      return result
    },
    [cityId],
  )

  return {
    getAmbassadors,
    getAllAmbassadors,
    updateAmbassador,
    deleteAmbassador,
    getAmbassadorCalendarEvents,
    isLoadGetAmbassadors,
    progressOfGetAllAmbassadors,
  }
})(cache)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/gql.js